// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1571125006836
      var cssReload = require("D:/project/uniFrame/uni-frame/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  